import { isEmpty } from "lodash"
import React, { useEffect, useState } from "react"
import Chart from "react-apexcharts"
import { useSelector, useDispatch } from "react-redux"

const GenderChart = () => {
  const { genderdistribution } = useSelector(state => state.Dashboard)
  const [labels, setLabels] = useState([])
  const [series, setSeries] = useState([])

  useEffect(() => {
    if (!isEmpty(genderdistribution)) {
      setLabels(genderdistribution[0].Labels.split(","))
      setSeries(genderdistribution[0].Series?.split(",").map(Number))
    }
  }, [genderdistribution])

  const options = {
    labels: labels,
    colors: ["#008FFB", "#00E396", "#FEB019"],
    legend: {
      position: "bottom",
    },
  }

  return (
    <div>
      <Chart options={options} series={series} type="pie" height={300} />
    </div>
  )
}

export default GenderChart
